import { RootState } from '../../../Redux/Store';
import { useAppSelector } from '../../../Hooks/Hooks';
import { convertCurrencyFormatWithDecimals } from '../../../Utils/Basic';
import './BookNowTable.scss';

interface TBookNowTableProps {
  data: any;
  isMyLoads?: boolean;
  tableTitle: string;
  tableColumnTitle?: string[];
  totalCostAmount?: string;
}

const TableRowsContent = (props: any) => {
  const {
    chargeDescription,
    accessorialDescription,
    unitCharge,
    accessorialUnitCharge,
    rateQualifier,
    accessorialRateQualifier,
    quantity,
    accessorialQuantity,
    charge,
    accessorialTotalCharge,
    tableTitle,
    costBreakdownDescription,
    costBreakdownQty,
    costBreakdownRate,
    costBreakdownRateQlfr,
    costBreakdownTotalAmount,
  } = props;

  const description = chargeDescription || accessorialDescription || costBreakdownDescription;
  const chargePerUnit = unitCharge || accessorialUnitCharge || costBreakdownRate;
  const rate = rateQualifier || accessorialRateQualifier || costBreakdownRateQlfr;
  const quantityValue = quantity || accessorialQuantity || costBreakdownQty;
  const totalCharge = charge || accessorialTotalCharge || costBreakdownTotalAmount;

  return (
    <div className={`Table_Row ${tableTitle ? '' : 'modal_row'}`}>
      <span>{description}</span>
      <span>{`${chargePerUnit}/${rate}`}</span>
      <span>{quantityValue}</span>
      {charge || costBreakdownRateQlfr ? (
        <span>${convertCurrencyFormatWithDecimals(totalCharge)}</span>
      ) : null}
    </div>
  );
};

const BookNowTable = (props: TBookNowTableProps) => {
  const { configTableData } = useAppSelector((state: RootState) => state.ContentOrConfig);
  const { memberData } = useAppSelector((state: RootState) => state.member);
  const { data, tableTitle, tableColumnTitle, totalCostAmount, isMyLoads = false } = props;
  const hasCharge = !!data?.lineHaulCharge?.charge || !!data?.fuelCharge?.charge;

  const shouldShowRateGrid = (_configTableData: any, _memberData: any): boolean => {
    const userPayType = _memberData?.member?.userApplicationDetails?.[0]?.attributes?.PayType;
    const rateGridLookup = _configTableData?.RATE_GRID_LOOKUP_BY_PAY_TYPE || [];
    const payTypeConfig = rateGridLookup.find((item: any) => item?.payType === userPayType);
    const defaultConfig = rateGridLookup.find((item: any) => item?.payType === 'Default');
    if (payTypeConfig) {
      return payTypeConfig?.showRateGrid?.toLowerCase() === 'true';
    }
    return defaultConfig?.showRateGrid;
  };

  return (
    <div className={`Book_Table ${tableTitle ? '' : 'modal_container'}`}>
      {tableTitle && (
        <div className="Table_Header">
          <span>{tableTitle}</span>
        </div>
      )}
      {shouldShowRateGrid(configTableData, memberData) &&
        (data ? (
          <div className="Table_Container">
            <div className={`Table_Column ${tableTitle ? '' : 'modal_grid'}`}>
              {tableColumnTitle?.map((item: string) => <span key={item}>{item}</span>)}
            </div>
            <div className="Table_Body">
              {isMyLoads &&
                data?.map((item: any) => <TableRowsContent tableTitle={tableTitle} {...item} />)}
              {hasCharge && data?.lineHaulCharge && (
                <TableRowsContent tableTitle={tableTitle} {...data?.lineHaulCharge} />
              )}
              {hasCharge && data?.fuelCharge && (
                <TableRowsContent tableTitle={tableTitle} {...data?.fuelCharge} />
              )}
              {hasCharge &&
                data?.accessorials?.map((item: any) => (
                  <TableRowsContent
                    tableTitle={tableTitle}
                    key={item?.accessorialCode + item?.accessorialTotalCharge}
                    {...item}
                  />
                ))}
            </div>
          </div>
        ) : (
          <div data-testid="NoData" className="No_Data">
            No data available.
          </div>
        ))}
      <div className={`Table_Total ${tableTitle ? '' : 'modal_total'}`}>
        {data?.totalCharge || totalCostAmount ? (
          <>
            <span>Total</span>
            <span>${totalCostAmount || convertCurrencyFormatWithDecimals(data?.totalCharge)}</span>
          </>
        ) : null}
      </div>
    </div>
  );
};

export default BookNowTable;
